import React from 'react';
import { languageList } from '../../../../utils/i18n';
import i18next from 'i18next';
import { useTranslation } from 'react-i18next';

export default function Language() {
    const { t } = useTranslation();
    return (
        <div className={'flex flex-col gap-1 py-4 md:flex-row md:gap-3'}>
            <div className={'w-full text-slate-600 md:w-1/3'}>
                {t('translation:MY_ACCOUNT.PROFILE.PREFERRED_LANGUAGE')}
            </div>
            <div className={'flex w-full gap-5'}>
                {languageList.map((language) => {
                    return (
                        <button
                            key={`language-${language}`}
                            onClick={() => i18next.changeLanguage(language)}
                            type={'button'}
                            className={`${
                                language === i18next.language
                                    ? 'bg-SM-yellow'
                                    : 'border-2 border-SM-dark/40'
                            } h-8 w-8 rounded pt-0.5`}>
                            {language.toUpperCase()}
                        </button>
                    );
                })}
            </div>
        </div>
    );
}
